module.exports = __webpack_public_path__ + "static/media/Apple iPad Pro 11\" Silver - Landscape.e0a8e9ad.png";